/**
 * Load different events depending on the page hash.
 * Bind an event to $(window).bind('pageaspectclean', func()) which is run before each aspect is run
 * (use to hide any previous aspect) 
 */
(function($){
	
	/**
	 * Add a function to execute when a specific hash is triggered
	 *
	 * @param string The hash minus the #
	 * @param function A function to execute when that hash is called
	 */
	$.bindPageAspect = function(hash, func){
		var aspects = $('body').data('pageaspects');
		if(typeof aspects != 'object') aspects = {};
		
		if(hash === '_ALWAYS_') {
			if(typeof aspects[hash] !== 'object') {
				aspects[hash] = [];
			}

			aspects[hash].push(func);
		}
		else {
			aspects[hash] = func;
		}
		
		$('body').data('pageaspects', aspects);
	};
		
	// The actual event to run when the hash changes
	$(window).hashchange( function(){
		var hash = location.hash;
		
		var aspects = $('body').data('pageaspects');
		
		// If there are no bound events, don't do anything
		if(typeof aspects != 'object') return false;
		
		// Remove the # from the hash
		hash = hash.replace(/^#/, '');
		location.hash = '';
		
		// Find the existing aspect
		if(typeof aspects[hash] != 'undefined' && $.isFunction(aspects[hash])){
			$(window).trigger('pageaspectclean');
			aspects[hash]();
		}
		
		// Handle global aspects
		if(typeof aspects['_ALWAYS_'] === 'object') {
			for(var i in aspects['_ALWAYS_']) {
				if(aspects['_ALWAYS_'].hasOwnProperty(i)) {
					if ($.isFunction(aspects['_ALWAYS_'][i])) {
						aspects['_ALWAYS_'][i](hash);
					}
				}
			}
		}
	});
		
})(jQuery);
